<template>
  <NuxtLink
    :to="`/${item.slug}`"
    class="editorial-article-card"
    :class="{ 'featured-article': featured }"
    data-testid="blog-item"
  >
    <div class="article-card-art">
      <BlogArtwork :item="item" />
    </div>
    <div class="article-card-copy">
      <div class="article-card-meta">
        <span data-testid="blog-item-topic">{{ articleTopic(item) }}</span>
        <span>{{ item.readingTime?.text }}</span>
      </div>
      <h2 :data-testid="`blog-item-title-${item.slug}`">{{ item.title }}</h2>
      <p>{{ item.description }}</p>
      <div class="article-card-bottom">
        <time :datetime="item.date">{{ formatDate(item.date) }}</time>
        <span class="article-card-arrow" aria-hidden="true">↗</span>
      </div>
    </div>
  </NuxtLink>
</template>
<script setup lang="ts">
import type { Article } from '~/types/article'
import { articleTopic } from '~/helpers/articleTopic'
import { formatDate } from '~/helpers/formatDate'
defineProps<{ item: Article; featured?: boolean }>()
</script>
